import api from "../api";
import apiToken from "../apiToken";

class PointsRepository {

    async getPointsList() {
        try {
            const response = await api.get('/marketplace/point-products');
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /* {{urlDKFLocal}}/point-products/:id */

    async getPointProductById(id) {
        try {
            const response = await apiToken.get(`/point-products/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default PointsRepository;